import { DatasetType, DatasetSubtype } from 'src/app/modules/core/store/models/dataset.model';

export const DatasetZIndexValues = {
  [DatasetType.Alerts]: {
    [DatasetSubtype.None]: 2000,
    [DatasetSubtype.Intelligence]: 2000,
    [DatasetSubtype.Rating]: 2000,
    [DatasetSubtype.Weather]: 2000,
    [DatasetSubtype.TropicalCyclone]: 2000,
    [DatasetSubtype.Wildfire]: 2000,
    [DatasetSubtype.Earthquake]: 2000,
    [DatasetSubtype.MobileEvent]: 2000,
    [DatasetSubtype.PowerOutage]: 2000,
    [DatasetSubtype.Flight]: 2000
  },
  [DatasetType.Assets]: {
    [DatasetSubtype.Facility]: 1000,
    [DatasetSubtype.Person]: 1000,
    [DatasetSubtype.HorizonPerson]: 1000,
    [DatasetSubtype.Shipment]: 1000,
    [DatasetSubtype.TravelItinerary]: 1000,
    [DatasetSubtype.Device]: 1000,
    [DatasetSubtype.Assignment]: 1000,
    [DatasetSubtype.Flight]: 1000,
    [DatasetSubtype.Vehicle]: 1000
  },
  [DatasetType.Metrics]: {
    [DatasetSubtype.None]: 1000
  },
  [DatasetType.PointOfInterest]: {
    [DatasetSubtype.None]: 1000
  },
  [DatasetType.Camera]: {
    [DatasetSubtype.None]: 1000,
    [DatasetSubtype.Single]: 1000,
    [DatasetSubtype.Group]: 1000,
    [DatasetSubtype.Traffic]: 1000,
    [DatasetSubtype.AgentVmsIntegration]: 1000
  },
  [DatasetType.Alarm]: {
    [DatasetSubtype.None]: 1000
  },
  [DatasetType.Incident]: {
    [DatasetSubtype.None]: 3000,
    [DatasetSubtype.Incident]: 3000,
    [DatasetSubtype.Timeline]: 3000,
    [DatasetSubtype.InvolvedParty]: 3000,
    [DatasetSubtype.Issue]: 3000,
    [DatasetSubtype.StatusUpdate]: 3000
  },
  [DatasetType.Geofence]: {
    [DatasetSubtype.None]: 500
  },
  [DatasetType.ActivityLog]: {
    [DatasetSubtype.None]: 500
  },
  [DatasetType.Picklist]: {
    [DatasetSubtype.None]: 500
  },
  [DatasetType.Default]: {
    [DatasetSubtype.HorizonAirlines]: 3000,
    [DatasetSubtype.HorizonLocations]: 3000,
    [DatasetSubtype.HorizonCategory]: 1000
  }
};
